import { api } from './api';
import { isValidRouteDocumentId } from '../utils/documentRouteUtils';

export interface PublicSignatureInvite {
  requiresRegistration: boolean;
  signerEmailMasked: string;
  signerId: string;
  signerName: string;
  signatureType: number;
  documentId: string;
  documentTitle: string;
  documentVersionId?: string | null;
  signatureRequestId: string;
  signatureRule: number;
  tokenExpiresAtUtc?: string | null;
  requiresStrongAuthentication: boolean;
}

export interface RegisterFromInvitePayload {
  name: string;
  password: string;
  confirmPassword: string;
  cpf: string;
  birthDate: string;
}

export interface RegisterFromInviteResult {
  documentId: string;
  email: string;
  message: string;
}

export async function fetchSignatureInvite(token: string): Promise<PublicSignatureInvite> {
  const encoded = encodeURIComponent(token);
  const { data } = await api.get<PublicSignatureInvite>(`/public/sign/${encoded}`);
  return data;
}

export async function registerFromSignatureInvite(
  token: string,
  payload: RegisterFromInvitePayload
): Promise<RegisterFromInviteResult> {
  const encoded = encodeURIComponent(token);
  const { data } = await api.post<RegisterFromInviteResult>(`/public/sign/${encoded}/register`, payload);
  return data;
}

export function buildDocumentDetailsPath(documentId: string, inviteToken?: string): string {
  if (!isValidRouteDocumentId(documentId)) {
    return '/sign/inbox';
  }
  if (inviteToken)
  {
    return `/documents/${documentId}/details?inviteToken=${encodeURIComponent(inviteToken)}`;
  }

  return `/documents/${documentId}/details`;
}

/** Após login, fluxo do visitante (perfil user): inbox dedicada com token do convite na query. */
export function buildVisitorSignInboxDocumentPath(documentId: string, inviteToken?: string): string {
  if (!isValidRouteDocumentId(documentId)) {
    return '/sign/inbox';
  }
  if (inviteToken) {
    return `/sign/inbox/${documentId}?inviteToken=${encodeURIComponent(inviteToken)}`;
  }

  return `/sign/inbox/${documentId}`;
}
